[
    {
        "id": "intro",
        "name": "It's time to power up your adventures!",
        "order": 1,
        "path": "/build/page/intro",
        "component": "Intro",
        "showInSidebar": false,
        "hideExitButton": true,
        "hideGradient": true
    },
    {
        "id": "get-started",
        "name": "Our global team is online",
        "order": 2,
        "path": "/build/page/get-started",
        "component": "GetStarted",
        "showInSidebar": false,
        "hideExitButton": true,
        "hideGradient": true
    },
    {
        "id": "country",
        "name": "Select your country",
        "group": "GetStarted",
        "order": 3,
        "path": "/build/page/country",
        "component": "CountrySelect",
        "showInSidebar": false,
        "responses": ["country"]
    },
    {
        "order": 4,
        "id": "vehicle-type",
        "name": "What type of vehicle do you have?",
        "group": "GetStarted",
        "path": "/build/page/vehicle-type",
        "component": "Multi",
        "showInSidebar": false,
        "responses": ["vehicle_type"],
        "questions": [
            {
                "id": "vehicle_type",
                "response": "vehicle_type",
                "order": 1,
                "type": "multi",
                "exitValues": [
                    "Class_A_motorhome",
                    "Class_C_motorhome",
                    "Trailer_or_5th_wheel"
                ],
                "options": {
                    "usa": [
                        {
                            "label": "Class A motorhome",
                            "value": "Class_A_motorhome",
                            "image": "enq_Class_A_rrnw09",
                            "imgHeight": 103
                        },
                        {
                            "label": "Class B campervan",
                            "value": "Class_B_campervan",
                            "image": "enq_Class_B_j24cqy",
                            "imgHeight": 103
                        },
                        {
                            "label": "Class C motorhome",
                            "value": "Class_C_motorhome",
                            "image": "enq_Class_C_npxvsa",
                            "imgHeight": 103
                        },
                        {
                            "label": "Overlander",
                            "value": "Overlander",
                            "image": "enq_Overlander_lbgbll",
                            "imgHeight": 103
                        },
                        {
                            "label": "Truck camper",
                            "value": "Truck_camper",
                            "image": "enq_Truck_i4i1xm",
                            "imgHeight": 103
                        },
                        {
                            "label": "Bus or skoolie",
                            "value": "Bus_or_skoolie",
                            "image": "enq_Class_A_copy_o9ufmd",
                            "imgHeight": 103
                        },
                        {
                            "label": "Trailer or 5th wheel",
                            "value": "Trailer_or_5th_wheel",
                            "image": "enq_5th_wheel_vaazmi",
                            "imgHeight": 103
                        },
                        {
                            "label": "Mobile business",
                            "value": "Mobile_business",
                            "image": "enq_Commercial_qf6yv0",
                            "imgHeight": 103
                        }
                    ],
                    "uk": [
                        {
                            "label": "Campervan",
                            "value": "Campervan",
                            "image": "enq_Class_B_j24cqy",
                            "imgHeight": 103
                        },
                        {
                            "label": "Motorhome",
                            "value": "Motorhome",
                            "image": "enq_Class_C_npxvsa",
                            "imgHeight": 103
                        },
                        {
                            "label": "Overlander",
                            "value": "Overlander",
                            "image": "enq_Overlander_lbgbll",
                            "imgHeight": 103
                        },
                        {
                            "label": "Mobile business",
                            "value": "Mobile_business",
                            "image": "enq_Commercial_qf6yv0",
                            "imgHeight": 103
                        }
                    ]
                }
            }
        ]
    },
    {
        "id": "about-you",
        "name": "About you",
        "order": 5,
        "path": "/build/page/about-you",
        "component": "Form",
        "focus": "first_name",
        "group": "About you",
        "responses": ["first_name", "last_name", "email", "phone"],
        "questions": [
            {
                "id": "first_name",
                "response": "first_name",
                "order": 1,
                "type": "text",
                "question": "First name",
                "placeholder": "First name",
                "ts_type": "string",
                "validation": {
                    "required": "Required",
                    "maxLength": {
                        "value": 100,
                        "message": "First Name must be less than 100 characters"
                    }
                }
            },
            {
                "id": "last_name",
                "response": "last_name",
                "order": 2,
                "type": "text",
                "question": "Last name",
                "placeholder": "Last name",
                "ts_type": "string",
                "validation": {
                    "required": "Required",
                }
            },
            {
                "id": "email",
                "response": "email",
                "order": 3,
                "type": "email",
                "question": "Email",
                "placeholder": "Email",
                "ts_type": "string",
                "validation": {
                    "required": "Required",
                    "pattern": {
                        "value": "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                        "message": "Invalid email address"
                    }
                }
            },
            {
                "id": "mailchimp",
                "order": 4,
            },
            {
                "id": "phone",
                "response": "phone",
                "order": 5,
                "type": "tel",
                "question": "Phone",
                "placeholder": "Phone",
                "required": true,
                "ts_type": "string",
                "validation": {
                    "required": "Required",
                    "pattern": {
                        "value": "^[\\d\\s()+-]{9,20}$",
                        "message": "Invalid phone number"
                    }
                }
            }
        ]
    },
    {
        "order": 6,
        "id": "map",
        "name": "Map",
        "path": "/build/page/map",
        "component": "Map",
        "group": "About you"
    },
    {
        "order": 7,
        "id": "frequency",
        "name": "How often will you use your vehicle?",
        "path": "/build/page/frequency",
        "component": "Multi",
        "group": "About you",
        "responses": ["how_often"],
        "questions": [
            {
                "id": "how_often",
                "response": "how_often",
                "order": 1,
                "type": "multi",
                "options": [
                    {
                        "label": "1-2 days & short trips",
                        "value": "1-2_days_&_short_trips",
                        "image": "enq_Commercial_copy_3_qvonca"
                    },
                    {
                        "label": "1-2 week trips",
                        "value": "1-2_week_trips",
                        "image": "enq_Commercial_copy_4_huitkz"
                    },
                    {
                        "label": "Longer trips",
                        "value": "Longer_trips",
                        "image": "enq_Commercial_copy_5_uhn1kp"
                    },
                    {
                        "label": "Full-time",
                        "value": "Full-time",
                        "image": "enq_Commercial_copy_6_r09pne"
                    }
                ]
            }
        ]
    },
    {
        "order": 8,
        "id": "adventure",
        "name": "Choose your adventure",
        "description": {
            "uk": "Let us know how you will spend your time. On and off-grid means you will spend time both off-grid and on campsites.",
            "usa": "Let us know how you will spend your time. On and off-grid means you will spend time both off-grid and on campgrounds."
        },
        "path": "/build/page/adventure",
        "component": "Multi",
        "group": "About you",
        "responses": ["adventure"],
        "questions": [
            {
                "id": "adventure",
                "response": "adventure",
                "order": 1,
                "type": "multi",
                "options": {
                    "uk": [
                        {
                            "label": "Totally off-grid",
                            "value": "off-grid",
                            "image": "where_Commercial_copy_qjunhy.png"
                        },
                        {
                            "label": "On and off-grid",
                            "value": "on-off-grid",
                            "image": "where_Commercial_copy_12_j1aw7o.png"
                        },
                        {
                            "label": "Only campsites",
                            "value": "campsites",
                            "image": "where_Commercial_copy_21_jnvno5.png"
                        }
                    ],
                    "usa": [
                        {
                            "label": "Totally off-grid",
                            "value": "off-grid",
                            "image": "where_Commercial_copy_qjunhy.png"
                        },
                        {
                            "label": "On and off-grid",
                            "value": "on-off-grid",
                            "image": "where_Commercial_copy_12_j1aw7o.png"
                        },
                        {
                            "label": "Only campgrounds",
                            "value": "campsites",
                            "image": "where_Commercial_copy_21_jnvno5.png"
                        }
                    ]
                }
            }
        ]
    },
    {
        "order": 9,
        "id": "off-grid",
        "name": "How much time will you typically spend off-grid at a time?",
        "path": "/build/page/off-grid",
        "component": "Multi",
        "group": "About you",
        "dependencies": [{
            "question": "adventure",
            "values": ["on-off-grid"]
        }],
        "responses": ["off-grid"],
        "questions": [
            {
                "id": "off-grid",
                "response": "off-grid",
                "order": 1,
                "type": "multi",
                "options": [
                    {
                        "textBase": "1-2 days",
                        "value": "1-2 days"
                    },
                    {
                        "textBase": "3-5 days",
                        "value": "3-5 days"
                    },
                    {
                        "textBase": "6-9 days",
                        "value": "6-9 days"
                    },
                    {
                        "textBase": "10+ days",
                        "value": "10+ days"
                    }
                ]
            }
        ]
    },
    {
        "order": 10,
        "id": "stage",
        "name": "What stage of your conversion are you at?",
        "path": "/build/page/stage",
        "component": "Multi",
        "group": "Your build",
        "responses": ["stage"],
        "questions": [
            {
                "id": "stage",
                "response": "stage",
                "order": 1,
                "type": "multi",
                "options": [
                    {
                        "label": "No van - planning",
                        "value": "No van",
                        "image": "enq_Commercial_copy_8_k2rrdk"
                    },
                    {
                        "label": "Early build",
                        "value": "Early build",
                        "image": "enq_Commercial_copy_7_cuu4qa"
                    },
                    {
                        "label": "Ready for electrics",
                        "value": "Ready for electrics",
                        "image": "enq_Commercial_copy_2_km50tv"
                    }
                ]
            }
        ]
    },
    {
        "order": 11,
        "id": "budget",
        "name": "What’s your budget?",
        "description": "Our engineers use this information to ensure your system is tailored to your budget and requirements.",
        "path": "/build/page/budget",
        "component": "Multi",
        "group": "Your build",
        "responses": ["budget"],
        "questions": [
            {
                "id": "budget",
                "response": "budget",
                "order": 1,
                "type": "multi",
                "options": {
                    "uk": [
                        {
                            "textBase": "£1,500-£2,000",
                            "textItalic": "Essential electrical systems",
                            "value": "£1,500-£2,000",
                            "descriptionTitle": "What does it include?",
                            "description": "An essential electrical system typically includes a small lithium battery, solar panel and B2B. Power mains appliances when connected to hook-up, or if you will be fully off-grid, it could include a small inverter to power low-wattage mains appliances."
                        },
                        {
                            "textBase": "£2,000-£2,750",
                            "textItalic": "Mid-range electrical systems",
                            "value": "£2,000-£2,750",
                            "descriptionTitle": "What does it include?",
                            "description": "A mid-range electrical system typically includes a mid-size solar array, B2B and lithium battery. Power low-wattage mains appliances off-grid and use higher-power appliances on hook-up. Or, if you will be fully off-grid, it may include a mid-size inverter."
                        },
                        {
                            "textBase": "£2,750-£4,000",
                            "textItalic": "High performance electrical systems",
                            "value": "£2,750-£4,000",
                            "descriptionTitle": "What does it include?",
                            "description": "A high performance electrical system typically includes a mid-size inverter/charger and lithium battery bank. Recharge from hook-up (if required), solar and B2B. If you will be fully off-grid, it may include a large inverter and battery for high-wattage mains appliances."
                        },
                        {
                            "textBase": "£4,000+",
                            "textItalic": "Luxury electrical systems",
                            "value": "£4,000+",
                            "descriptionTitle": "What does it include?",
                            "description": "A luxury electrical system allows you to go off-grid for longer using multiple high-wattage appliances with a large inverter, shore power, solar array, multiple B2Bs and lithium batteries."
                        }
                    ],
                    "usa": [
                        {
                            "textBase": "$2,000-$3,500",
                            "textItalic": "Essential electrical systems",
                            "value": "$2,000-$3,500",
                            "descriptionTitle": "What does it include?",
                            "description": "An essential electrical system typically includes a small lithium battery, solar panel and B2B. Power mains appliances when connected to hook-up, or if you will be fully off-grid, it could include a small inverter to power low-wattage mains appliances."
                        },
                        {
                            "textBase": "$3,500-$6,000",
                            "textItalic": "Mid-range electrical systems",
                            "value": "$3,500-$6,000",
                            "descriptionTitle": "What does it include?",
                            "description": "A mid-range electrical system typically includes a mid-size solar array, B2B and lithium battery. Power low-wattage mains appliances off-grid and use higher-power appliances on hook-up. Or, if you will be fully off-grid, it may include a mid-size inverter."
                        },
                        {
                            "textBase": "$6,000-$10,000",
                            "textItalic": "High performance electrical systems",
                            "value": "$6,000-$10,000",
                            "descriptionTitle": "What does it include?",
                            "description": "A high performance electrical system typically includes a mid-size inverter/charger and lithium battery bank. Recharge from hook-up (if required), solar and B2B. If you will be fully off-grid, it may include a large inverter and battery for high-wattage mains appliances."
                        },
                        {
                            "textBase": "$10,000+",
                            "textItalic": "Luxury electrical systems",
                            "value": "$10,000+",
                            "descriptionTitle": "What does it include?",
                            "description": "A luxury electrical system allows you to go off-grid for longer using multiple high-wattage appliances with a large inverter, shore power, solar array, multiple B2Bs and lithium batteries."
                        }
                    ]
                }
            }
        ]
    },
    {
        "id": "vehicle-details",
        "name": "Tell us more about your vehicle",
        "order": 12,
        "path": "/build/page/vehicle-details",
        "component": "Form",
        "focus": "vehicle_make",
        "group": "Your build",
        "responses": ["vehicle_make_model", "year", "vehicle_type", "starter_voltage", "vehicle_length"],
        "questions": [
            {
                "id": "vehicle_make_model",
                "response": "vehicle_make_model",
                "order": 1,
                "type": "text",
                "question": "Vehicle make and model",
                "placeholder": "Mercedes Sprinter 313",
                "ts_type": "string",
                "validation": {
                    "required": "Required"
                }
            },
            {
                "id": "year",
                "response": "year",
                "order": 2,
                "type": "text",
                "question": "Year",
                "placeholder": "2018",
                "ts_type": "string",
                "width": "w-1/2",
                "validation": {
                    "required": "Required",
                    "pattern": {
                        "value": "^[0-9]{4}$",
                        "message": "Invalid year"
                    }
                }
            },
            {
                "id": "vehicle_power",
                "response": "vehicle_power",
                "order": 3,
                "type": "select",
                "question": "What is your vehicle's fuel type?",
                "placeholder": "Please select an option",
                "required": true,
                "ts_type": "string",
                "options": [
                    {
                        "label": "Petrol/Diesel",
                        "value": "Diesel"
                    },
                    {
                        "label": "Hybrid (Petrol/Diesel + Electric)",
                        "value": "Hybrid"
                    },
                    {
                        "label": "Electric Vehicle (EV)",
                        "value": "EV"
                    }
                ],
                "validation": {
                    "required": "Required"
                }
            },
            {
                "id": "starter_voltage",
                "response": "starter_voltage",
                "order": 4,
                "type": "select",
                "question": "Starter battery voltage",
                "placeholder": "Please select an option",
                "required": true,
                "ts_type": "string",
                "options": [
                    {
                        "label": "12V",
                        "value": "12V"
                    },
                    {
                        "label": "24V",
                        "value": "24V"
                    }
                ],
                "validation": {
                    "required": "Required"
                }
            },
            {
                "id": "vehicle_length",
                "response": "vehicle_length",
                "order": 5,
                "type": "select",
                "question": "How long is your vehicle?",
                "placeholder": "Please select an option",
                "required": true,
                "ts_type": "string",
                "options": {
                    "usa": [
                        {
                            "label": "10-15ft / XS (E.g. Ram ProMaster City, Mercedes Metris)",
                            "value": "10-15ft"
                        },
                        {
                            "label": "15-20ft / Small (E.g. Ford Transit, Chevy Express)",
                            "value": "15-20ft"
                        },
                        {
                            "label": "20-25ft / Medium (E.g. LWB Mercedes Sprinter, RAM Promaster, Unimog)",
                            "value": "20-25ft"
                        },
                        {
                            "label": "25-35ft / Large (E.g. Class C Motorhome)",
                            "value": "25-35ft"
                        },
                        {
                            "label": "35-45ft / XL (E.g. Class A Motorhome or Fifth Wheel)",
                            "value": "35-45ft"
                        }
                    ],
                    "uk": [
                        {
                            "label": "3-4m / XS (E.g. VW Caddy)",
                            "value": "3-4m"
                        },
                        {
                            "label": "4-5m / Small (E.g. VW Transporter)",
                            "value": "4-5m"
                        },
                        {
                            "label": "5-6m / Medium (E.g. Ford Transit, Renault Master)",
                            "value": "5-6m"
                        },
                        {
                            "label": "6-7.5m / Large (E.g. LWB Mercedes Sprinter)",
                            "value": "6-7.5m"
                        },
                        {
                            "label": "7.5-9m - XL (E.g. Unimog)",
                            "value": "7.5-9m"
                        }
                    ]
                },
                "validation": {
                    "required": "Required"
                }
            }
        ]
    },
    {
        "id": "appliances",
        "name": "Tell us which appliances you will use",
        "note": "You can add custom items and edit existing items on the next page. ",
        "order": 13,
        "path": "/build/page/appliances",
        "component": "Form",
        "focus": "first_name",
        "group": "Appliances",
        "responses": ["appliances"],
        "questions": [
            {
                "id": "dc_appliances",
                "response": "appliances",
                "order": 1,
                "type": "checkbox",
                "question": "⚡  DC (12/24V) appliances",
                "ts_type": "string",
                "validation": {
                    "required": "Required"
                }
            },
            {
                "id": "ac_appliances",
                "response": "appliances",
                "order": 2,
                "type": "checkbox",
                "question": "🔌  AC (230V) appliances",
                "ts_type": "string",
                "validation": {
                    "required": "Required"
                }
            }
        ]
    },
    {
        "order": 14,
        "id": "edit-appliances",
        "name": "Edit your appliances or add custom items",
        "description": "You can edit the voltage, wattage, quantity, and time used per day for each item. Default values are provided, so you can keep these if you’re unsure - or dive in and refine all the parameters to suit your needs.",
        "path": "/build/page/edit-appliances",
        "component": "AppliancePicker",
        "group": "Appliances",
        "responses": ["appliances"]
    },
    {
        "order": 15,
        "id": "shore",
        "name": "Would you like to include shore hook-up?",
        "dependencies": [{
            "question": "adventure",
            "values": ["off-grid", "on-off-grid"]
        }],
        "description": {
            "uk": "Shore hook-up allows you to recharge at home or from a campsite hook-up. It’s a valuable back-up power source, even if you plan to spend most of your time off-grid.",
            "usa": "Shore hook-up allows you to recharge at home or from a campground hook-up. It’s a valuable back-up power source, even if you plan to spend most of your time off-grid."
        },
        "path": "/build/page/shore",
        "component": "Multi",
        "group": "Equipment",
        "responses": ["shore_hook-up"],
        "questions": [
            {
                "id": "shore_hook-up",
                "response": "shore_hook-up",
                "order": 1,
                "type": "multi",
                "trigger": "offgrid",
                "options": [
                    {
                        "label": "Include hook-up",
                        "value": "Include_hook-up",
                        "image": "enq_X_copy_z5dnkw"
                    },
                    {
                        "label": "No shore hook-up",
                        "value": "No_shore_hook-up",
                        "image": "enq_X_atas63"
                    }
                ]
            }
        ]
    },
    {
        "order": 16,
        "id": "off-grid-appliances",
        "name": "Which of your 230V appliances will you use off-grid?",
        "dependAll": true,
        "dependencies": [
            {
                "question": "shore_hook-up",
                "values": ["Include_hook-up", null]
            },
            {
                "function": "hasACAppliances"
            }
        ],
        "description": "The appliances you decide to use off-grid have the biggest impact on your system and its cost. Only using certain appliances when you're connected to campsite hook-up will result in a smaller inverter, battery bank and ultimately, a lower system cost.",
        "path": "/build/page/off-grid-appliances",
        "component": "OffGridAppliances",
        "group": "Appliances",
        "responses": ["appliances"]
    },
    {
        "order": 17,
        "id": "shore-inlet",
        "dependencies": [
            {
                "question": "shore_hook-up",
                "values": ["Include_hook-up"]
            },
            {
                "question": "adventure",
                "values": ["campsites"]
            }
        ],
        "name": "Which shore inlet would you like to include?",
        "path": "/build/page/shore-inlet",
        "component": "ProductSelector",
        "group": "Equipment",
        "responses": ["shore-inlet"],
        "products": {
            "uk": [
                {
                    "name": "White square inlet",
                    "value": "White square inlet",
                    "description": "",
                    "price": "£25",
                    "image": "white_square_inlet_hxofxd.png"
                },
                {
                    "name": "Black square inlet",
                    "value": "Black square inlet",
                    "description": "",
                    "price": "£25",
                    "image": "Black_square_inlet_o7zmqh.png"
                },
                {
                    "name": "Premium white inlet",
                    "value": "Premium white inlet",
                    "description": "Only compatible with Victron shore power cables",
                    "price": "£65",
                    "image": "victron_inlet_qxmude.png"
                },
                {
                    "name": "Premium chrome inlet",
                    "value": "Premium chrome inlet",
                    "description": "Only compatible with Victron shore power cables",
                    "price": "£99",
                    "image": "chrome_inlet_de08b6.png"
                },
                {
                    "name": "Surface mount inlet",
                    "value": "Surface mount inlet",
                    "description": "For mounting beneath the vehicle",
                    "price": "£10",
                    "image": "inlet_1_fztz4n.png"
                },
                {
                    "name": "No inlet required",
                    "value": "No inlet",
                    "description": "",
                    "image": "enq_X_atas63"
                }
            ],
            "usa": [
                {
                    "name": "White non-metallic inlet",
                    "value": "White non-metallic inlet",
                    "description": "",
                    "price": "~$110",
                    "image": "marinco_plastic_mvmbbr.png"
                },
                {
                    "name": "Stainless steel inlet",
                    "value": "Stainless steel inlet",
                    "description": "",
                    "price": "~$200",
                    "image": "chrome_inlet_zknr7b.png"
                },
                {
                    "name": "No inlet required",
                    "value": "No inlet",
                    "description": "",
                    "image": "enq_X_atas63"
                }
            ]
        }
    },
    {
        "order": 18,
        "id": "shore-cable",
        "dependencies": [
            {
                "question": "shore_hook-up",
                "values": ["Include_hook-up"]
            },
            {
                "question": "adventure",
                "values": ["campsites"]
            }
        ],
        "name": "What length shore power cable would you like?",
        "description": "We automatically include a compatible shore power cable for your choice of inlet.",
        "path": "/build/page/shore-cable",
        "component": "Multi",
        "group": "Equipment",
        "responses": ["shore_cable_length"],
        "questions": [
            {
                "id": "shore_cable_length",
                "response": "shore_cable_length",
                "order": 1,
                "type": "multi",
                "options": {
                    "uk": [
                        {
                            "label": "15m",
                            "value": "15m",
                            "image": "enq_UK_copy_3_iiyzzh"
                        },
                        {
                            "label": "25m",
                            "value": "25m",
                            "image": "enq_UK_copy_2_cmnq5q"
                        },
                        {
                            "label": "I’ll provide my own",
                            "value": "No cable",
                            "image": "enq_X_atas63"
                        }
                    ],
                    "usa": [
                        {
                            "label": "25ft",
                            "value": "25ft",
                            "image": "enq_UK_copy_3_iiyzzh"
                        },
                        {
                            "label": "50ft",
                            "value": "50ft",
                            "image": "enq_UK_copy_2_cmnq5q"
                        },
                        {
                            "label": "I’ll provide my own",
                            "value": "No cable",
                            "image": "enq_X_atas63"
                        }
                    ]
                }
            }
        ]
    },
    {
        "order": 19,
        "id": "battery-distance",
        "name": "What is the distance between your electrical system and your vehicle’s starter battery?",
        "path": "/build/page/battery-distance",
        "component": "Multi",
        "group": "Equipment",
        "responses": ["battery_distance"],
        "bannerImage": {
            "uk": "starter_battery_distance_km9smc",
            "usa": "cable_length_vv-56_o8ryhn.png"
        },
        "bannerImageMobile": {
            "uk": "starter_battery_distance_-_mobile_u44uml",
            "usa": "cable_length_vv-58_gqoevj.png"
        },
        "questions": [
            {
                "id": "battery_distance",
                "response": "battery_distance",
                "order": 1,
                "type": "multi",
                "options": {
                    "uk": [
                        {
                            "textBase": "0-3m",
                            "value": "0-3m"
                        },
                        {
                            "textBase": "3-5m",
                            "value": "3-5m"
                        },
                        {
                            "textBase": "5-9m",
                            "value": "5-9m"
                        }
                    ],
                    "usa": [
                        {
                            "textBase": "0-10ft",
                            "value": "0-10ft"
                        },
                        {
                            "textBase": "10-16ft",
                            "value": "10-16ft"
                        },
                        {
                            "textBase": "16-30ft",
                            "value": "16-30ft"
                        }
                    ]
                }
            }
        ]
    },
    {
        "order": 20,
        "id": "solar-type",
        "name": "What type of solar panels would you like?",
        "path": "/build/page/solar-type",
        "component": "ProductSelector",
        "group": "Equipment",
        "responses": ["solar-type"],
        "products": [
            {
                "name": "Rigid solar panels",
                "value": "Rigid solar panels",
                "description": "Most efficient and durable, 25+ year lifespan, best value",
                "price_uk": "~£0.60 per W",
                "price_usa": "~$1 per W",
                "image": "rigid_solar_panel_qxlq4k"
            },
            {
                "name": "Flexible solar panels",
                "value": "Flexible solar panels",
                "description": "Lightweight, low profile, much less durable than rigid",
                "price_uk": "~£1.60 per W",
                "price_usa": "~$1.70 per W",
                "image": "felxible_solar_panel_v0dzlf"
            },
            {
                "name": "Portable solar panels",
                "value": "Portable solar panels",
                "description": "High yield when angled, less durable than rigid",
                "price_uk": "~£2.40 per W",
                "price_usa": "~$1.70 per W",
                "image": "portable_solar_panel_vy1rta"
            },
            {
                "name": "I don't want solar",
                "value": "No solar",
                "description": "We will prioritise other recharging methods instead",
                "image": "enq_X_atas63"
            }
        ]
    },
    {
        "order": 21,
        "id": "solar-distance",
        "name": "What’s the distance between your electrical system and your solar cable entry?",
        "dependencies": [{
            "question": "solar-type",
            "values": [
                "Rigid solar panels",
                "Flexible solar panels",
                "Portable solar panels"
            ]
        }],
        "path": "/build/page/solar-distance",
        "component": "Multi",
        "group": "Equipment",
        "responses": ["solar_distance"],
        "bannerImage": {
            "uk": "solar_distance_xmpb0q",
            "usa": "us_solar-55_irdwcb.png"
        },
        "bannerImageMobile": {
            "uk": "solar_distance_-_mobile_jzwsdh",
            "usa": "us_solar-57_ugppea.png"
        },
        "questions": [
            {
                "id": "solar_distance",
                "response": "solar_distance",
                "order": 1,
                "type": "multi",
                "options": {
                    "uk":[
                        {
                            "textBase": "0-3m",
                            "value": "0-3m"
                        },
                        {
                            "textBase": "3-5m",
                            "value": "3-5m"
                        },
                        {
                            "textBase": "5-9m",
                            "value": "5-9m"
                        }
                    ],
                    "usa": [
                        {
                            "textBase": "0-10ft",
                            "value": "0-10ft"
                        },
                        {
                            "textBase": "10-16ft",
                            "value": "10-16ft"
                        },
                        {
                            "textBase": "16-30ft",
                            "value": "16-30ft"
                        }
                    ]
                }
            }
        ]
    },
    {
        "order": 22,
        "id": "generator",        
        "name": "Do you plan to use a generator to support your power usage?",
        "path": "/build/page/generator",
        "dependencies": [{
            "question": "country",
            "values": ["usa"]
        }],
        "component": "Multi",
        "group": "Equipment",
        "responses": ["generator"],
        "questions": [
            {
                "id": "generator",
                "response": "generator",
                "order": 1,
                "type": "multi",
                "options": [
                    {
                        "label": "Yes",
                        "value": "Yes",
                        "image": "generator_eosmwl.png"
                    },
                    {
                        "label": "No",
                        "value": "No",
                        "image": "enq_X_atas63"
                    }
                ]
            }
        ]
    },
    // {
    //     "order": 23,
    //     "id": "switches",
    //     "name": "Would you like to include additional switches for your sub-systems?",
    //     "description": "These are not essential, however, they allow you to easily isolate each individual sub-system.",
    //     "path": "/build/page/switches",
    //     "component": "ProductSelector",
    //     "group": "Equipment",
    //     "responses": ["switches"],
    //     "products": [
    //         {
    //             "name": "Include additional switches",
    //             "value": "Additional switches",
    //             "description": "Useful for isolating sub-systems or for control panels ",
    //             "price_uk": "~£35-70",
    //             "price_usa": "~$40-80",
    //             "image": "switches_co41sg.png"
    //         },
    //         {
    //             "name": "No additional switches",
    //             "value": "No additional switches",
    //             "description": "Essential switches and protective equipment still included",
    //             "image": "enq_X_atas63.png"
    //         }
    //     ]
    // },
    {
        "order": 23,
        "id": "monitoring",
        "name": "How would you like to monitor your system?",
        "description": "The cost of each option includes all additional items required, such as cables to connect to the major components in your electrical system.",
        "path": "/build/page/monitoring",
        "component": "ProductSelector",
        "group": "Equipment",
        "responses": ["monitoring"],
        "products": [
            {
                "name": "Built-in battery monitoring",
                "value": "Built-in battery monitoring",
                "description": "Monitor your battery via an app",
                "price_uk": "£0",
                "price_usa": "$0",
                "image": "phone_app_dci78d.png"
            },
            {
                "name": "BMV screen battery monitor",
                "value": "BMV screen battery monitor",
                "description": "Monitor your battery via an app & screen",
                "price_uk": "~£160",
                "price_usa": "~$200",
                "image": "bmv_qucuoi.png"
            },
            {
                "name": "Full system monitoring",
                "value": "Full system monitoring",
                "description": "Includes Cerbo GX only - monitor via Bluetooth",
                "price_uk": "~£220",
                "price_usa": "~$340",
                "image": "cerbo_lfmcc4.png"
            },
            {
                "name": "Full system monitor + 5” screen",
                "value": "Full system monitor 5 screen",
                "description": "Includes Cerbo GX & 5” GX Touch screen",
                "price_uk": "~£380",
                "price_usa": "~$560",
                "image": "5inch_cerbo_bpv1qz.png"
            },
            {
                "name": "Full system monitor + 7” screen",
                "value": "Full system monitor 7 screen",
                "description": "Includes Cerbo GX & 7” GX Touch screen",
                "price_uk": "~£440",
                "price_usa": "~$670",
                "image": "7inch_cerbo_gpshbc.png"
            },
            {
                "name": "All-in-one full system monitor with 7” screen",
                "value": "All-in-one full system monitor with 7 screen",
                "description": "Includes Ekrano GX",
                "price_uk": "~£440",
                "price_usa": "~$670",
                "image": "ekrano_w0rcgp.png"
            }
        ]
    },
    {
        "order": 24,
        "id": "installation",
        "name": "Would you like a quote for your system to be professionally installed at our Plymouth workshop?",
        "path": "/build/page/installation",
        "component": "Multi",
        "group": "Review",
        "responses": ["installation"],
        "questions": [
            {
                "id": "installation",
                "response": "installation",
                "order": 1,
                "type": "multi",
                "options": [
                    {
                        "textBase": "Yes",
                        "value": "yes"
                    },
                    {
                        "textBase": "No",
                        "value": "no"
                    },
                    {
                        "textBase": "Not sure yet",
                        "value": "not_sure_yet"
                    }
                ]
            }
        ]
    },
    {
        "order": 25,
        "id": "source",
        "name": "Final question! How did you hear about Nohma?",
        "path": "/build/page/source",
        "component": "Form",
        "group": "Review",
        "responses": ["source"],
        "questions": [
            {
                "id": "source",
                "response": "source",
                "order": 1,
                "type": "radio",
                "ts_type": "string",
                "validation": {
                    "required": "Required"
                },
                "options": [
                    {
                        "label": "The Van Conversion Bible",
                        "value": "The_Van_Conversion_Bible"
                    },
                    {
                        "label": "Recommended by a friend",
                        "value": "friend"
                    },
                    {
                        "label": "Facebook",
                        "value": "Facebook"
                    },
                    {
                        "label": "Instagram",
                        "value": "Instagram"
                    },
                    {
                        "label": "YouTube",
                        "value": "YouTube"
                    },
                    {
                        "label": "Email newsletter",
                        "value": "Email"
                    },
                    {
                        "label": "TikTok",
                        "value": "TikTok"
                    },
                    {
                        "label": "Google / search engine",
                        "value": "Google_search_engine"
                    },
                    {
                        "label": "Fogstar's website",
                        "value": "Fogstar"
                    },
                    {
                        "label": "Repeat customer",
                        "value": "Repeat_customer"
                    }
                ]
            }
        ]
    },
    {
        "order": 26,
        "id": "submit",
        "path": "/build/page/submit",
        "showInSidebar": false,
        "component": "Submit",
        "group": "Review",
        "responses": [],
        "hideGradient": true
    },
    {
        "order": 27,
        "id": "calendar",
        "path": "/build/page/calendar",
        "showInSidebar": false,
        "component": "Calendar",
        "group": "Review",
        "responses": [],
        "hideGradient": true,
        "dependencies": [{
            "question": "contact",
            "values": ["calendar"]
        }]
    },
    {
        "order": 28,
        "id": "complete",
        "path": "/build/page/complete",
        "showInSidebar": false,
        "component": "Final",
        "group": "Review",
        "responses": [],
        "hideExitButton": true,
        "hideGradient": true
    }
]